<template>
<div class="our-clients-section">
    <div class="overlay"></div>
<div class="container">
    <div class="our-customers">
        <h3>في بيترونكس نحن حريصون أن نقدم
            <div class="vertical-silder" style="">
                <div class="single-single_iteam">
                    <div><span>الجودة </span></div>
                </div>
                 <div class="single-single_iteam">
                    <div><span>الجمالية </span></div>
                </div>
                <div class="single-single_iteam">
                    <div><span>الدقة </span></div>
                </div>
                <div class="single-single_iteam">
                    <div><span>المصداقية</span></div>
                </div>
            </div>
            لعملائنا
        </h3>
    </div>
    <div class="clearfix"></div>
    <div class="slick_multiple_items" style="width:100%;height:120px;">
        <div v-for="item in clientsList" :key="item.Id" class="single-single_iteam client-item">
            <img :src="item.PictureUrl" class="img-responsive" />
        </div>
    </div>
</div>
</div>

</template>

<script>

import 'slick-carousel/slick/slick.min'
var Clients=[
        {
        Id:"1",
        PictureUrl:'/src/assets/img/clients/moony.png'
    },
     {
        Id:"2",
        PictureUrl:'/src/assets/img/clients/ubco.png'
    },
     {
        Id:"3",
        PictureUrl:'/src/assets/img/clients/nokhba-aleppo.png'
    },
    {
        Id:"4",
        PictureUrl:'/src/assets/img/clients/sima.png'
    },
     //{
       // Id:"5",
        // PictureUrl:'/src/assets/img/clients/sanaya.png'
    // },
     {
        Id:"6",
        PictureUrl:'/src/assets/img/clients/manar.png'
    },
     {
        Id:"7",
        PictureUrl:'/src/assets/img/clients/Biscotart.png'
    },
     {
        Id:"8",
        PictureUrl:'/src/assets/img/clients/alrouad.png'
    },
    {
        Id:"9",
        PictureUrl:'/src/assets/img/clients/ihsan.png'
    },
    {
        Id:"10",
        PictureUrl:'/src/assets/img/clients/moad.png'
    },
    {
        Id:"11",
        PictureUrl:'/src/assets/img/clients/aci.png'
    },
    {
        Id:"12",
        PictureUrl:'/src/assets/img/clients/NewHorizon.png'
    },
    {
        Id:"13",
        PictureUrl:'/src/assets/img/clients/nokhba.png'
    },
    {
        Id: "14",
        PictureUrl: '/src/assets/img/clients/rawda.png',
    },
    {
        Id:"15",
        PictureUrl:'/src/assets/img/clients/nahj.png'
    },
    {
        Id:"16",
        PictureUrl:'/src/assets/img/clients/mobadara.png'
    },
    {
        Id:"17",
        PictureUrl:'/src/assets/img/clients/saden.png'
    },
    {
        Id:"18",
        PictureUrl:'/src/assets/img/clients/bader.png'
    },
    {
        Id:"19",
        PictureUrl:'/src/assets/img/clients/alomar.png'
    },
];
export default {
name:"OurClients",
data(){
    return{
        clientsList:Clients
    }
},
 mounted: function() {
      $('.vertical-silder').slick({
                infinite: true,
                speed: 400,
                arrows: false,
                pauseOnHover: true,
                slidesToShow: 1,
                vertical:true,
                slidesToScroll: 1,
                autoplay: true,
                variableWidth: false,
                autoplaySpeed: 1000,
                cssEase: 'linear'
            });

      $('.slick_multiple_items').slick({
                infinite: true,
                speed: 800,
                arrows: false,
                rows: 1,
                rtl: false,
                pauseOnHover: true,
                slidesToShow: 4,
                slidesToScroll: 1,

                autoplay: true,
                variableWidth:false,
                autoplaySpeed: 3000,
                cssEase: 'linear',
                adaptiveHeight: true,
                responsive: [
                                 {
                                     breakpoint: 767,
                                     settings: {
                                         slidesToShow: 3,
                                         slidesToScroll: 1,
                                         infinite: true
                                     }
                                 },
                                   {
                                       breakpoint: 480,
                                       settings: {
                                           slidesToShow: 2,
                                           slidesToScroll: 1,
                                           infinite: true
                                       }
                                   },
                                   {
                                       breakpoint: 360,
                                       settings: {
                                           slidesToShow: 1,
                                           slidesToScroll: 1,
                                           infinite: true
                                       }
                                   },
                             ]
            });
  },

}
</script>
<style lang="scss">
@import "src/assets/sass/shared.scss";
@import 'node_modules/slick-carousel/slick/slick.scss';

.our-clients-section{
    background:url('/src/assets/img/pexels-photo-459689.jpeg') center center no-repeat fixed;
     @include prefixer(background-size,cover,("moz","webkit","ms","o"));
     position: relative;
     .overlay{
         position: absolute;
         top:0px;
         left:0px;
         width:100%;
         height:100%;
         background-color:rgba(#000,0.5);
     }
}
    .container{
        margin-top:30px;
    }
    .our-customers {
        text-align: center;
        margin-top:30px;
        margin-bottom:30px;
        h3{
            position: relative;
            color:#fff;

            .vertical-silder
            {
                overflow: hidden;
                display: inline-block;
                width:120px;
                overflow:hidden;
                vertical-align: bottom;
              }
        }
       span{
           color:$main-color;
       }

       .client-item{
           padding:10px;
           background-color:rgba(#fff,0.4);
       }
    }
</style>




// WEBPACK FOOTER //
// src/components/home/our-clients.vue